import jsPDF from 'jspdf';
import {Product} from "../services/api/invoice/model";


export function format_price(value: number | string): string {
  if (!value) return '';

  let numStr = value.toString().replace(/\s+/g, '');
  if (isNaN(Number(numStr))) return value.toString();

  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function format_invoice_price(value: number | string): string {
  if (!value) return '';

  let numStr = value.toString().replace(/\s+/g, '');
  if (isNaN(Number(numStr))) return value.toString();

  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function formatDateToMMDDYYYY(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

export function invoiceGenerator(clientName: string, products: Product[]): File {
  let total = products.reduce((acc, product) => acc + product.quantity * product.price, 0);
  const fontName = 'courier';

  const shopTitle = "TRANOMBAROTRA"
  const shopName = "RAKOTOARISOA Sylvain"
  const shopDescriptionLine1 = "Vente de marchandises générales"
  const shopDescriptionLine2 = "en détails"
  const shopAddress = "Pav 169 Andravoahangy Tsena"
  const confirmLine1 = "Hamarino ny entanao azafady"
  const confirmLine2 = "Ny entana efa lasa tsy azo averina na soloina"
  const thanksLine = "Misaotra indrindra !"

  // 80mm = 226.77 points (1mm = 2.83 points in jsPDF)
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: [80, 297] // 80mm width, A4 height
  });


  console.log(doc.getFontList())

  // Header
  doc.setFontSize(12);
  doc.setFont(fontName, 'bold');
  doc.text(shopTitle, 40, 5, {align: 'center'});
  doc.text(shopName, 40, 9, {align: 'center'});

  doc.setFontSize(10);
  doc.text(shopDescriptionLine1, 40, 15, {align: 'center'});
  doc.text(shopDescriptionLine2, 40, 19, {align: 'center'});

  doc.setFont(fontName, 'normal');
  doc.text(shopAddress, 40, 25, {align: 'center'});

  // Horizontal line
  doc.setLineWidth(0.1);
  doc.line(7, 30, 73, 30);

  // Date & Client Name
  const currentDate = new Date().toLocaleDateString();
  doc.text(`Date: ${currentDate}`, 3, 37);
  doc.text(`Client: ${clientName}`, 3, 42);


  // Invoice title
  let yPos = 50;
  doc.setFontSize(9);
  doc.setFont(fontName, 'bold');
  doc.text('Produit', 2, yPos);
  doc.text('Qté', 39, yPos);
  doc.text('Prix', 49, yPos);
  doc.text('Total', 65, yPos);
  doc.setFont(fontName, 'normal');

  // Add horizontal line
  yPos += 2;
  doc.line(2, yPos, 78, yPos);
  yPos += 5;


  // Invoice Product
  doc.setFontSize(7);
  products.forEach(product => {
    // Check if we need a new page
    if (yPos > 280) {
      doc.addPage();
      yPos = 15;
    }

    // Truncate description if too long
    const description = product.description.length > 20
      ? product.description.substring(0, 20) + '...'
      : product.description;

    doc.text(description, 2, yPos);
    doc.text(format_invoice_price(product.quantity), 39, yPos);
    doc.text(format_invoice_price(product.price), 49, yPos);
    doc.text(format_invoice_price(product.quantity * product.price), 65, yPos);

    yPos += 5;
  });

  // Add horizontal line
  doc.line(2, yPos, 78, yPos);
  yPos += 5;

  // Invoice total
  doc.setFontSize(9);
  doc.setFont(fontName, 'bold');
  doc.text('Total:', 35, yPos);
  doc.text(format_invoice_price(total), 50, yPos);
  doc.text('AR', 75, yPos);

  // Add footer
  yPos += 15;
  doc.setFontSize(8);

  doc.text(confirmLine1, 40, yPos, {align: 'center'});

  yPos += 5;
  doc.text(confirmLine2, 40, yPos, {align: 'center'});

  yPos += 10;
  doc.setFont(fontName, 'normal');
  doc.text(thanksLine, 40, yPos, {align: 'center'});

  // Convert the PDF to a blob and then to a File
  const pdfOutput = doc.output('blob');
  const file = new File([pdfOutput], 'invoice.pdf', {type: 'application/pdf'});

  // Save the PDF for preview
  //doc.save('invoice.pdf');
  doc.output('dataurlnewwindow');

  return file
}
